String.prototype.ellipsis = function ellipsis(maxLength) {
    return this.length > maxLength ? this.substr(0, maxLength - 2) + '…' : '' + this;
};

if (typeof String.prototype.startsWith != 'function') {
  String.prototype.startsWith = function (str){
    return this.slice(0, str.length) == str;
  };
}

String.prototype.rtrim = function trim() {
  return this.replace(/\s+$/,"");
};

String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.toSentence = function toSentence() {
    return this.replace(/\n\r|\r\n/g, ', ').replace(/\n|\r/g, ', ');
};

String.prototype.format = function format() {
    var args = arguments, rx = /\{(\d+)\}/g, fn = function(capture, p1) {
        return args[p1];
    };
    return this.replace(rx, fn);
};

String.prototype.htmlEncode = function htmlEncode() {
    return this.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\x22/g, '&quot;').replace(/\x27/g, '&#39;');
};

String.prototype.htmlDecode = function htmlDecode() {
    return this.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '\x22').replace(/&#39;/g, "\x27").replace(/&amp;/g, '&');
};

String.prototype.stripHtml = function stripHtml() {
    //https://github.com/kangax/prototype/blob/a223833c8b49ae55f03b1e1a3a5b7e9fb647c139/src/lang/string.js#L470
    return this.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
};

String.prototype.isEmpty = function isEmpty() {
    return this.trim() === "";
};

define("lib/prototype/String.prototype", function(){});

